const requestUrl = {

    // /sys/web/cn/area/2020/get/level
    // 区域行政
    POST_AREA_LEVEL:"/sys/web/cn/area/2020/get/level",
    // to/web/file/simple/download
    FILESIM:"to/web/file/simple/download",
    // 获取图片验证码
    GET_IMG_CAPTCHA: "/to/img/cap/get",
    // 获取手机验证码
    GET_PHONE_CAPTCHA: "/to/sms/send",
    // 验证手机号或密码是否存在
    GET_EXIST:"/do/check/user",
    // 登录
    ORDINARY_LOGIN: "/do/login",
    // 注册
    POST_REGISTER:"/do/register",
    // 获取用户菜单
    GET_USER_MENU: "/do/get/menu",
    // 获取用户信息
    GET_USER_INFO: "/do/get/user",
    // 获取所有菜单
    GET_ALL_MENU: "/sys/web/menu/get/all",
    // /do/get/user/permission 获取用户权限
    GET_USER_PERMISSION:"/do/get/user/permission",
    // /sys/web/menu/up
    POST_MENU_UP:"/sys/web/menu/up",
    // 菜单添加 /sys/web/menu/add
    POST_MENU_ADD:"/sys/web/menu/add",
    // 获取菜单下的角色 
    POST_MENUROLE:"/sys/web/menu/get/role",
    // 删除菜单
    DELETE_MENU:"/sys/web/menu/del/",
    // sys/web/dict/get/by/type
    // 获取用户机构列表
    // GET_USER_OFFICE_TREE: "sys/web/get/user/office/tree",
    // 机构详情
    GET_USER_DETAILS:"/sys/web/get/office/1",
    GET_USER_OFFICE_TREE: "/sys/web/get/user/office/tree",
    // 获取机构列表
    POST_OFFICE_LIST:"/sys/web/get/office/list",
    // 楼宇信息树
    GET_FLOOR_TREE:"/wy/web/floor/get/tree",
    // 获取房间下的业主 /wy/web/floor/get/roomAndCrm/
    GET_FLOOR_LIST:"/wy/web/floor/get/roomAndCrm",
    // 楼宇详情 /wy/web/floor/get/
    GET_FLOOR_WEB:"/wy/web/floor/get/",
    // 机构详情
    GET_USER_DETAILSL:"/sys/web/get/office/",
    // /sys/web/del/office/
    DELETE_OFFICE:"/sys/web/del/office/",
    // /sys/web/has/office/code/
    GET_OFFICE_CODE:"/sys/web/has/office/code/",
    POST_OFFICE_ADD:"/sys/web/add/office",
    PUT_UP_OFFICE:"/sys/web/up/office",
    // /sys/web/dict/get/by/type
    POST_USER_TYPE:"/sys/web/dict/get/by/type",
    // /sys/web/query/userAndRole/
    GET_ROLE_JUR:"/sys/web/query/userAndRole/",
    // /sys/web/up/userAndRole
    POST_USER_SEVE:"/sys/web/up/userAndRole",
    // 用户管理 获取用户
    POST_USER_LIST:"/sys/web/get/user/page",
    // 删除用户 /sys/web/del/user/
    DELETE_USER:"/sys/web/del/user/",
    // /sys/web/del/user/role
    DELETE_USER_ROLE:"/sys/web/del/user/role", // 删除角色里的用户
    // /sys/web/get/user/role
    GET_USER_ROLE:"/sys/web/get/user/role",
    // 修改用户 /sys/web/up/user
    POST_USER_AMEND:"/sys/web/up/user",
    // 重置密码 /sys/web/reset/user/pwd
    PUT_RESE_PWD:"/sys/web/reset/user/pwd",
    // 获取角色  /sys/web/get/role/list
    POST_ROLE_LIST:"/sys/web/get/role/list",
        // /sys/web/add/role
    POST_ADD_ROLE:"/sys/web/add/role",
    // 删除角色 /sys/web/del/user/
    DELETE_ROLE:"/sys/web/del/role/",
    // 获取角色详情 /sys/web/get/role/
    GET_ROLE_DETAILS:"/sys/web/get/role/",
    // /sys/web/add/user/role
    POST_ROLE_ADD_USER:"/sys/web/add/user/role",
    // 修改角色信息 /sys/web/up/role
    GET_ROLE_AMEND:"/sys/web/up/role",
    // 字典管理 /sys/web/dict/get/list
    POST_DICT_LIST:"/sys/web/dict/get/list",
    // 修改字典 /sys/web/dict/up
    PUT_DICT_AMEND:"/sys/web/dict/up",
    // 添加字典 /sys/web/dict/add
    POST_DICT_ADD:"/sys/web/dict/add",
    // 删除字典 /sys/web/dict/del/{id}
    DELETE_DICT:"/sys/web/dict/del/",
    // 检测键值 /sys/web/dict/check/v/1
    DETECTION_DICT:"/sys/web/dict/v/check",
    // sys/web/dictget/all/type
    DICTGET_TYPE:"/sys/web/dictget/all/type",
    // 字典详情 
    GET_DICT_DETAILS:"/sys/web/dict/get/",
    // 房间管理——项目管理 /wy/web/project/get/list
    POST_PROJECT_LIST:"/wy/web/project/get/list",
    // 添加项目  /wy/web/project/add
    POST_PROJECT_ADD:"/wy/web/project/add",
    // 修改项目
    PUT_PROJECT_AMEND:"/wy/web/project/up",
    // 删除项目 /wy/web/project/del/
    DELETE_PROJECT:"/wy/web/project/del/",
    // 楼宇管理  /wy/web/floor/get/list
    POST_BUILDING_LIST:"/wy/web/floor/get/list",
    // 修改楼宇 /wy/web/floor/up
    PUT_BUILDING_AMEND:"/wy/web/floor/up",
    // 添加楼宇 
    POST_BUILDING_ADD:"/wy/web/floor/add",
    // 删除楼宇
    DELETE_BUILDING:"/wy/web/floor/del/",
    // 房间管理 
    POST_ROOM_LIST:"/wy/web/room/get/list",
    // /wy/web/room/get/  房间详情
    GEI_WY_ROOM:"/wy/web/room/get/",
    // 修改房间 
    PUT_ROOM_AMEND:"/wy/web/room/up",
    // 添加房间 
    POST_ROOM_ADD:"/wy/web/room/add",
    // 删除房间
    DELETE_ROOM:"/wy/web/room/del/",
    // 房间绑定列表
    POST_ROOM_BOUND:"/wy/web/wyRoomCheckUser/get/listByPage",
    // 解绑/wy/web/wyRoomCheckUser/untie/del
    GET_UNDIND:"/wy/web/wyRoomCheckUser/untie/del",
    POST_AUDIT_REFUSED:"/wy/web/wyRoomCheckUser/audit/passOrRefuse",
    // 企业房产列表
    POST_COMPANY_LIST:"/wy/web/wyRoomCheckUser/get/ent/listByPage",
    // 解绑
    GET_COMPANY_UNDIND:"/wy/web/wyRoomCheckUser/untie/ent/del",
    // 审核和拒绝
    POST_COMPANY_AUDIT_REFUSED:"/wy/web/wyRoomCheckUser/audit/ent/passOrRefuse",
    // 业主管理 
    POST_OWNER_LIST:"/wy/web/crm/get/list",
    // 修改业主 
    PUT_OWNER_AMEND:"/wy/web/crm/up",
    // 迁入业主 
    POST_OWNER_ADD:"/wy/web/crm/move/in",
    // 迁出业主
    DELETE_OWNER:"/wy/web/crm/move/out",
    // 会计科目管理 
    POST_CHARGE_LIST:"/charge/web/chargeSubjects/selectListPage",
    // 修改会计科目 
    POST_CHARGE:"/charge/web/chargeSubjects/save",
    // 主键查询会计科目 
    POST_CHARGE_CHECK:"/charge/web/chargeSubjects/queryById",
    // 删除会计科目
    DELETE_CHARGE:"/charge/web/chargeSubjects/delete",
    // 收款方式
    POST_RECEIPT_LIST:"/charge/web/chargeMethod/selectListPage",
    // 不分页 “charge/web/chargeMethod/selectList
    POST_CHARGE_METHOD:"/charge/web/chargeMethod/selectList",
    // 添加收款方式 
    POST_RECEIPT_ADD:"/charge/web/chargeMethod/save",
    // 删除收款方式
    POST_DELETE_RECEIPT:"/charge/web/chargeMethod/delete",
    // 收费项目
    POST_ITEM_LIST:"/charge/web/chargeFeeitem/selectListPage",
    // 添加收费项目 
    POST_ITEM_ADD:"/charge/web/chargeFeeitem/save",
    // 删除收费项目
    POST_DELETE_ITEM:"/charge/web/chargeFeeitem/delete",
    // 收费项目类别
    GET_ITEM_TYPE:"/charge/web/chargeFeeitem/getFeeCategory",
    // 收费项目去重
    GET_ITEM_WEIGHT:"/charge/web/chargeFeeitem/getAllFeeItem",
    // 对应科目
    GET_CHARGE_LIST:"/charge/web/chargeSubjects/selectList",
    // 开票项目
    POST_INVOICE_LIST:"/charge/web/chargeTaxControlPanel/selectListPage",
    // 添加开票项目 
    POST_INVOICE_ADD:"/charge/web/chargeTaxControlPanel/save",
    // 删除开票项目
    POST_DELETE_INVOICE:"/charge/web/chargeTaxControlPanel/delete",
    // 应用其他项目
    POST_INVOICE_TYPE:"/charge/web/chargeTaxControlPanel/addTaxControl",



    // charge/web/chargeBills/scarpInvoice   日常收费-票据作废
    POST_WEB_SCARPINVOICE:"/charge/web/chargeBills/scarpInvoice",
    // 房间收费标准
    POST_ROOMCHARGE_LIST:"/charge/web/chargeStandard/selectListByPage",
    // 添加房间收费标准
    POST_ROOMCHARGE_ADD:"/charge/web/chargeStandard/save",
   // 批量添加房间收费标准
    POST_BATCH_ROOMCHARGE:"/charge/web/chargeStandard/addbatch",
    // 删除
    DELETE_ROOMCHARGE:"/charge/web/chargeStandard/delete",

    // 票据类型设置 
    POST_BILL_LIST:"/charge/web/chargeInvoiceType/selectListPage",
    // 保存票据类型
    POST_BILL_ADD:"/charge/web/chargeInvoiceType/save",
    // 删除票据类型
    DELETE_BILL:"/charge/web/chargeInvoiceType/delete",
    // 根据定额类型查询 
    QUOTA_INQUIRE:"/charge/web/chargeInvoiceType/getInvoiceTypeByIsFixed",
    // 不分页 票据类型设置
    POST_BILLLIST_TYPE:"/charge/web/chargeInvoiceType/selectList",
    POST_LIST_ALL:"/charge/web/chargeFeeitem/getFeeCategoryAll",
    // 票据管理组
    POST_BILL_MANLIST:"/charge/web/chargeInvoiceMangroup/selectListPage",
    GET_BILL_MAMLIST:"/charge/web/chargeInvoiceMangroup/selectList",
    // 保存票据管理组
    POST_BILL_MANADD:"/charge/web/chargeInvoiceMangroup/save",
    // 删除票据管理组
    DELETE_BILL_MAN:"/charge/web/chargeInvoiceMangroup/delete",
    // 根据票据管理组获取票据类型   /charge/web/chargeInvoiceMangroupType/getInvoiceByGroupId
    GET_GROUP:"/charge/web/chargeInvoiceMangroupType/getInvoiceByGroupId",
    // 票据管理人员
    POST_BILL_MANAGERLIST:"/charge/web/chargeInvoiceManpeople/selectListPage",
    // 保存
    POST_BILL_MANAGERADD:"/charge/web/chargeInvoiceManpeople/save",
    // 删除
    DELETE_BILL_MANAGER:"/charge/web/chargeInvoiceManpeople/delete",

    // 票据管理部门
    POST_BILL_DEPARTLIST:"/charge/web/chargeInvoiceMangroupPosition/selectListPage",
    // 保存
    POST_BILL_DEPARTADD:"/charge/web/chargeInvoiceMangroupPosition/save",
    // 删除
    DELETE_BILL_DEPART:"/charge/web/chargeInvoiceMangroupPosition/delete",

    // 票据类型设置
    POST_BILLTYPE_LIST:"/charge/web/chargeInvoiceMangroupType/selectListPage",
    // 保存
    POST_BILLTYPE_ADD:"/charge/web/chargeInvoiceMangroupType/save",
    // 删除
    DELETE_BILLTYPE:"/charge/web/chargeInvoiceMangroupType/delete",
    // 票据共享部门设置
    POST_BILLSHARE_LIST:"/charge/web/chargeInvoiceShared/selectListPage",
    // 保存
    POST_BILLSHARE_ADD:"/charge/web/chargeInvoiceShared/save",
    // 删除
    DELETE_BILLSHARE:"/charge/web/chargeInvoiceShared/delete",
    // 票据入库
    POST_STORAGE_LIST:"/charge/web/chargeInvoiceInhouse/selectListPage",
    // 批量入库
    POST_BATCH_STORAGE:"/charge/web/chargeInvoiceInhouse/batchSave",
    // 保存
    POST_STORAGE_ADD:"/charge/web/chargeInvoiceInhouse/save",
    // 删除
    DELETE_STORAGE:"/charge/web/chargeInvoiceInhouse/delete",
    // 票据分配列表 
    POST_ALLOCATION_LIST:"/charge/web/chargeInvoiceDistribution/list",
    // 保存 
    POST_ALLOCATION_ADD:"/charge/web/chargeInvoiceDistribution/saveUse",
    // 票据领用列表
    POST_RECEIVE_LIST:"/charge/web/chargeInvoiceInhouse/selectListPage",
    // 删除
    DELETE_RECEIVE:"/charge/web/chargeInvoiceInhouse/delete",
    // 票据作废
    CANCELLATION_RECEIVE:"/charge/web/chargeInvoiceUse/invoiceInvalid",
    // 退票
    RETREAT_RECEIVE:"/charge/web/chargeInvoiceUse/invoiceUseRemove",
    // 票据领用
    POST_RECEIVE:"/charge/web/chargeInvoiceUse/invoiceUseSave",
    // 根据票据管理组获取下部门
    // /charge/web/chargeInvoiceMangroupPosition/getPositionByMangroupId
    // 票据核销 /charge/web/cancellation/selectListByPage
    POST_NUCLEUS_LIST:"/charge/web/cancellation/selectListByPage",
    // 核销保存 /charge/web/cancellation/cancellation
    POST_NUCLEUS_SAVE:"/charge/web/cancellation/cancellation",
    // 核销
    POST_NUCLEUS_REMO:"/charge/web/cancellation/remoInvoice",
    // 详情
    POST_NUCLEUS_DETAILS:"/charge/web/cancellation/getDetailList",
    
    // 账单列表/wy/web/crm/getRoomAndOwnerListByFloorIdsAndProjectIds
    POST_BILLLIST:"/wy/web/crm/getRoomAndOwnerListByFloorIdsAndProjectIds",
    // 生成账单  /charge/web/chargeBills/getfee
    POST_CREATE_BILL:"/charge/web/chargeBills/getfee",
    // 押金退款 列表  /charge/web/chargeBills/deposit
    // POST_CASHPLEDGE_LIST:"/charge/web/chargeBills/depositbills",
    POST_CASHPLEDGE_LIST:"/charge/web/chargeDeposit/depositbills",
    // 应收账单 /charge/web/chargeBillsAdjust/list
    POST_CHARGE_BILLSADJUST_LIST:"/charge/web/chargeBillsAdjust/list",
    POST_RECEIVABLE_LIST:"/charge/web/chargeBills/dailyList",
    // 退款
    POST_RECEIVABLE_QUIT:"/charge/web/chargeBillsAdjust/adjustmentRefund",
    // 作废
    POST_RECEIVABLE_VOID:"/charge/web/chargeBillsAdjust/cancel",
    // 调整
    POST_RECEIVABLE_ADJUST:"/charge/web/chargeBillsAdjust/save",
    // /charge/web/chargeBillsAdjust/updateDates
    POST_DATE_ADJUST:"/charge/web/chargeBillsAdjust/updateDates",
    // 催缴通知单打印 /charge/web/prompt/selectList
    POST_INFORM_LIST:"/charge/web/prompt/selectList",
    // 打印 /charge/web/prompt/printing
    POST_PRINT:"/charge/web/prompt/printing",
    // 票据重开 /charge/web/chargeBills/reopenInvoice
    POST_BILLREOPEN:"/charge/web/chargeBills/reopenInvoice",
    // 票据收款确定保存 /charge/web/chargeBills/updatebills
    POST_CONFIRM_SAVE:"/charge/web/chargeBills/updatebills",
    // 批量定额票据 /charge/web/chargeBills/updatefixinvoice
    POST_BATCH_SAVE:"/charge/web/chargeBills/updatefixinvoice",
    // 票据作废 POST_RECEIVABLE_VOID
    // 日常收费-其他收费列表 /charge/web/chargeBills/getOtherBills
    POST_ELSE_CHARGE_LIST:"/charge/web/chargeBills/getOtherBills",

    // /charge/web/chargeInvoiceInhouse/getInvoiceOwnOpend
    POST_BILLSBYSTU:"/charge/web/chargeInvoiceInhouse/getInvoiceOwnOpend",
    // 收款情况查询charge/web/chargeBills/getbillsbystu
    POST_CHERGE_BILLS:"/charge/web/chargeBills/getbillsbystu",
    // charge/web/chargeBills/delete
    // 日常收费作废
    DELETE_BILLS:"/charge/web/chargeBills/delete",
    // /charge/web/chargeBills/merge
    POST_MERGE:"/charge/web/chargeBills/merge",
    // /charge/web/chargeBills/dailyForm
    POST_DAILFORM:"/charge/web/chargeBills/dailyForm",
    // 收费日报表
    POST_COLLDAY_LIST:"/charge/web/report/reportList",
    // 打印收据 /charge/web/report/printArea
    POST_PRINTRECEIPT:"/charge/web/report/printArea",
    // 日收款汇总列表
    POST_COLLECT_LIST:"/charge/web/report/day/collectReport",
    // 押金 列表获取 /charge/web/report/depositList
    POST_REPOSTDEPOLIST:"/charge/web/report/depositList",
    // 票据作废报表
    POST_BILLINALID:"/charge/web/report/invalidInvoice/list",
    // 线下电子票据 
    POST_OFFLINE_BILLS:"/charge/web/report/offlineList",
    // 线下电子票据查看
    POST_OFFLINE_CHECK:"/charge/web/report/parIct",
    // 线下电子票据红冲 /charge/web/report/refund
    POST_OFFLINE_REDDASHED:"/charge/web/report/refund",
    // 实收年度 /charge/web/report/annualSummaryList
    POST_ANNUAL_LIST:"/charge/web/report/annualSummaryList",
    // /sys/web/query/user 员工数据
    POST_STAFF:"/sys/web/query/user",
    // 项目列表 wy/web/project/get/by/user
    GET_PROJECT_TREE:"wy/web/project/get/by/user",




    // 巡检分类列表
    POST_POLLING_LIST:"/inspect/type/list",
    // 删除  
    DELETE_POST_POLLING:"/inspect/type/delete/",
    // 修改 
    POST_POLLIMG_UPDATE:"/inspect/type/update",
    // 添加
    POST_POLLING_ADD:"/inspect/type/add",


    // 巡检标准
    POST_STAND_LIST:"/inspect/stand/list",
    // 标准添加
    POST_STAND_SAVE:"/inspect/stand/add",
    // 标准修改
    POST_STAND_UPDATE:"/inspect/stand/update",
    // 标准删除
    DELETE_GET_STAND:"/inspect/stand/delete/",

    // 巡检点位列表 /inspect/spot/list
    POST_SPOT_LIST:"/inspect/spot/list",
    // 巡检删除
    DELETE_GET_SPOT:"/inspect/spot/delete/",
    // 巡检添加
    POST_SPOT_SEVE:"/inspect/spot/add",
    // 点位修改
    POST_SPOT_UPDETE:"/inspect/spot/update",

    // /inspect/project/getArea  查询所有区域
    GET_AREA_LIST:"/inspect/project/getArea",

    // 巡检分配 /inspect/allot/list
    POST_ALLOT_LIST:"/inspect/allot/list",
    // /inspect/allot/delete/
    GET_DELETE_ALLOT:"/inspect/allot/delete/",
    // /inspect/allot/update
    POST_ALLOT_UPDATE:"/inspect/allot/update",
    POST_ALLOT_ADD:"/inspect/allot/add",


    // 巡检任务 /inspect/task/list
    POST_TASK_LIST:"/inspect/task/list",
    // /inspect/task/delete/
    DELETE_TASK:"/inspect/task/delete/",
    POST_TASK_UPDATE:"/inspect/task/update",
    POST_TASK_ADD:"/inspect/task/add",


    // /inspect/log/list巡检记录
    POST_LOG_LIST:"/inspect/log/list",

    // 巡检任务记录 /inspect/tasklog/list
    POST_TASKLOG_LIST:"/inspect/tasklog/list",
    // /inspect/tasklog/detail
    POST_TASKLOG_DETAIL:"/inspect/tasklog/detail",

    // /inspect/log/exList异常工单列表
    POST_EXLIST_LIST:"/inspect/log/exList",
    // /inspect/total/list巡检统计
    POST_TOTAL_LIST:"/inspect/total/list",



    // /to/web/file/get/icon/list   // 图标列表
    ICON_POST_LIST:"/to/web/file/get/icon/list",
    // /to/web/file/icon/upload 
    ICON_UPLPAD_FILE:"/to/web/file/icon/upload",
    // /to/web/file/del/icon
    ICON_DEL_FILE:"/to/web/file/del/icon",


    // 岗位管理--- 员工
    // /sys/web/user/position/list
    POST_SYS_LIST:"/sys/web/user/position/list",
    // 获取所有岗位（供下拉菜单用）
    POST_GET_ALL_POSITION:"sys/web/dict/get/all/position",
    // 开设账号
    SET_USER_ACCOUNT:"sys/web/user/position/add/account/",
    // 用户离岗
    SET_USER_OUT_POSITION:"sys/web/user/position/out/position/",



    // 系统配置 /sys/web/application/config/list
    POST_SYS_CONFIG_LIST:"/sys/web/application/config/list",
    // 删除系统配置 /sys/web/application/config/del/
    DELETE_SYS_CONFIG:"/sys/web/application/config/del/",
    // 新增系统配置 /sys/web/application/config/add
    POST_SYS_CONFIG_ADD:"/sys/web/application/config/add",
    // 更新系统配置 /sys/web/application/config/up
    PUT_SYS_CONFIG_UP:"/sys/web/application/config/up",
    // 重置系统配置 /sys/web/application/config/reset/key/
    GET_SYS_CONFIG_KEY:"/sys/web/application/config/reset/key/",


    // 支付配置列表 /pay/web/config/list
    POST_PAY_CONFIG_LIST:"/pay/web/config/list",
    // 删除支付配置 /pay/web/config/del/{id}
    DELETE_PAY_CONFIG:"/pay/web/config/del/",
    // 新增支付配置 /pay/web/config/add
    POST_PAY_ADD:"/pay/web/config/add",
    // 更新支付配置  /pay/web/config/up
    PUT_PAY_CONFIG_UP:"/pay/web/config/up",
    // 获取支付配置详情 /pay/web/config/get/
    GET_PAY_CONFIG:"/pay/web/config/get/",

    // 下载配置文件 /sys/web/application/config/download/2
    GET_SYS_CONFIG_DOWN:"/sys/web/application/config/download/",
    // 获取支付/业务类型 /sys/web/dict/get/by/type
    POST_SYS_CONFIG_TYPE:"/sys/web/dict/get/by/type",

}

export default requestUrl